// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M6 13Q5.58 13 5.29 12.71T5 12 5.29 11.29 6 11H18Q18.42 11 18.71 11.29T19 12 18.71 12.71 18 13Z"/>';

/** Minus (actions). */
const icon: IconData = {
  id: "minus",
  name: "Minus",
  category: "actions",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: '<path d="M5 13V11H19V13Z"/>' },
    outline: { svg: m0 },
    duotone: {
      svg: '<g opacity=".32"><path d="M6 13Q5.58 13 5.29 12.71T5 12 5.29 11.29 6 11H18Q18.42 11 18.71 11.29T19 12 18.71 12.71 18 13Z"/></g><path d="M6 13Q5.58 13 5.29 12.71T5 12 5.29 11.29 6 11H18Q18.42 11 18.71 11.29T19 12 18.71 12.71 18 13Z"/>',
    },
  },
  animation: () => import("../animations/minus.js"),
};

export default icon;
